export const referralPageStyles = {
  linkBox: {
    background: '#f3f7ff',
    borderRadius: 12,
    padding: 12,
  },
  statGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 12,
  } as const,
  paginationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginTop: 12,
  } as const,
};
